import Assets from "../assets"

import * as THREE from 'three';
import { Pane } from 'tweakpane';
import * as CamerakitPlugin from '@tweakpane/plugin-camerakit';
import Logo from "./logo"
import { HDRLoader } from 'three/examples/jsm/loaders/HDRLoader.js';

export default class Scene {
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera( 60, 1, 0.1, 60 );
    renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
    });
    intersectable = false;
    pointer = new THREE.Vector2();
    components = {};
    PARAMS = {
        x: 0,
        y: 0,
        z: 0,
        a: 1
    }
    constructor({ el }) {
        this.isDragging = false;
        this.autoRotationSpeed = 0.005;
        
        this.$graphics = el

        this.renderer.setClearColor( new THREE.Color(0x000000) );
        this.renderer.setClearAlpha( this.PARAMS.a );

        this.initialize();
        this.setComponents();

        this.setupDraggable();

        this.handleResize();
        this.boundResize = this.handleResize.bind(this);
        ScrollTrigger.addEventListener("refresh", this.boundResize)
        window.addEventListener("resize", this.boundResize);


        this.onMouseMove = this.onMouseMove.bind(this);
        window.addEventListener('mousemove', this.onMouseMove);
        
        this.renderer.setAnimationLoop(this.hanedleRender.bind(this));

        // The 4 MB environment map only adds reflections to the footer logo:
        // fetch it once the page is idle so it never delays page switches.
        Assets.whenIdle(() => this.loadHDR(this.renderer))
    }
    loadHDR(renderer) {
        const hdrLoader = new HDRLoader();
        const pmremGenerator = new THREE.PMREMGenerator(renderer);
        pmremGenerator.compileEquirectangularShader();

        hdrLoader.load('/wp-content/themes/cinetic/assets/models/HDRI_8K_001.hdr', (rawTexture) => {
            const envRT = pmremGenerator.fromEquirectangular(rawTexture);
            
            this.scene.environment = envRT.texture;

            rawTexture.dispose();
            pmremGenerator.dispose();
        });
}

    setupDraggable() {
        const _this = this;
        this.rotationProxy = { y: 0 };
        Draggable.create(document.createElement('div'), {
            trigger: this.$graphics,
            type: 'x',
            inertia: true,
            onPress: function() {
                _this.isDragging = true;
            },
            onRelease: function() {
                // Wait for inertia to finish or just resume
                _this.isDragging = false;
            },
            onDrag: function() {
                _this.updateRotation(this.x);
            },
            onThrowUpdate: function() {
                _this.updateRotation(this.x);
            }
        });
    }

    updateRotation(xValue) {
        if (this.components.logo && this.components.logo.rotor.children[0]) {
            this.components.logo.rotor.children[0].rotation.y = xValue / 200;
        }
        if (this.components.logo && this.components.logo.rotor2.children[0]) {
            this.components.logo.rotor2.children[0].rotation.y = (xValue / 200) * 0.5;
        }
    }
    setComponents() {
        const { scene, renderer } = this;

        this.components.logo = new Logo({ scene, renderer })
        this.components.logo.initialize()
    }

    initialize() {
        const { $graphics } = this;
        $graphics.prepend( this.renderer.domElement );

        this.camera.position.z = 3.14;

    }

    hide() {
        this.renderer.setAnimationLoop(null);
        this.$graphics.classList.add("hidden")
    }

    show() {
        this.renderer.setAnimationLoop(this.hanedleRender.bind(this));
        this.$graphics.classList.remove("hidden")
    }


    hanedleRender() {        
        this.camera.updateMatrixWorld();

        if (!this.isDragging && this.components.logo && this.components.logo.model) {
            this.components.logo.rotor.rotation.y += this.autoRotationSpeed;
            this.components.logo.rotor.children[0].children[1].visible = false
            // this.components.logo.model.children[1].rotation.y +=  this.autoRotationSpeed;
            this.components.logo.rotor2.rotation.y += this.autoRotationSpeed * 0.5;
            this.components.logo.rotor2.children[0].children[0].visible = false
                // console.log("this.model;", this.model.children[0])
        }

        this.renderer.render(this.scene, this.camera);
    }

    handleResize() {
        const width = window.innerWidth;
        const height = this.$graphics.offsetHeight;

        this.camera.aspect = width / height;
        this.renderer.setSize(width, height);

        const DESIGN_WIDTH = 814; 
        const DEFAULT_FOV = 60;   

        if (width < DESIGN_WIDTH) {
            const horizontalFov = DEFAULT_FOV * 1.25; 
            const aspect = width / height;
            
            const vFov = 2 * Math.atan(Math.tan(THREE.MathUtils.degToRad(horizontalFov) / 2) / aspect);
            this.camera.fov = THREE.MathUtils.radToDeg(vFov);
        } else {
            this.camera.fov = DEFAULT_FOV;
        }

        this.camera.updateProjectionMatrix();
    }

    onMouseMove(event) {
        this.pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }

    setDebug() {
        this.pane = new Pane();
        this.pane.registerPlugin(CamerakitPlugin);
        Object.keys(this.components).forEach(_ => {
            if ("setDebug" in this.components[_]) this.components[_].setDebug(this.pane);
        });
    }

    dispose() {
        Object.keys(this.components).forEach(_ => {
            this.components[_].dispose();
            delete this.components[_];
        });

        ScrollTrigger.removeEventListener("refresh", this.boundResize)
        window.removeEventListener("resize", this.boundResize);
        window.removeEventListener('mousemove', this.onMouseMove);
        this.renderer.dispose();
    }
}
